import type { FormInputProps, InputTypeState } from '~kui/types/input';
import type { NullableOptions } from '~kui/types/selectOption';

export const comboboxTypes = <const>{
  SELECT: 'select',
  SEARCH: 'search',
  MULTIPLE: 'multiple',
};

export type ComboboxTypes = (typeof comboboxTypes)[keyof typeof comboboxTypes];

export interface ComboboxProps extends FormInputProps {
  options: NullableOptions[];
  errorMessages?: string[];
  clearable?: boolean;
  nullable?: boolean;
  placeholder?: string;
  disabled?: boolean;
  dataTestId?: string;
  ignoreFilter?: boolean;
  loading?: boolean;
  version?: 'v1' | 'v2';
  type?: ComboboxTypes;
  inputTypeState?: InputTypeState;
  labelClass?: string;
}

export const comboboxDefaults = <const>{
  errorMessages: () => [],
  label: undefined,
  hideLabel: false,
  disabled: false,
  nullable: false,
  dataTestId: undefined,
  required: false,
  clearable: false,
  ignoreFilter: false,
  loading: false,
  inputTypeState: undefined,
  version: 'v1',
  labelClass: undefined,
};
